import { atom } from 'jotai';
import { request } from '@/config/request';
import { CustomerDetailRespDTO } from '@/service/customer';
import {
    getCountryByNavigatorLang,
    Site,
    simpleSite,
    SiteCodeMap
} from '@/const';
import { getToken } from '@/config/request/interceptors';
import { subscribe } from '@/hooks/subscribe';
import { getLocalSystemSource } from '@/utils';
export interface CustomerDetailRespDTO2 extends CustomerDetailRespDTO {
    site?: string;
    siteCode?: string;
    isKO?: boolean;
    isJA?: boolean;
    isEN?: boolean;
}
export const atomCustomerDetail = atom<CustomerDetailRespDTO2 | undefined>(
    undefined
);
interface USER_PROPS {
    stationCode?: Site;
    customerId?: string;
    siteCode?: string;
    site?: string;
    systemSource?: number;
}

export const getSite = (stationCode: string) => {
    if (stationCode === Site.JP) return simpleSite.JP;
    if (stationCode === Site.KR) return simpleSite.KR;
    return simpleSite.UK;
};
const atomRequestCustomerDetail = atom(
    (get) => get(atomCustomerDetail),
    async (_get, set) => {
        const defaultStationCode = getCountryByNavigatorLang();
        user.setState({
            stationCode: defaultStationCode,
            site: getSite(defaultStationCode),
            siteCode: SiteCodeMap.get(defaultStationCode),
            systemSource: getLocalSystemSource()
        });
        if (!getToken()) {
            set(atomCustomerDetail, {
                stationCode: defaultStationCode,
                siteCode: SiteCodeMap.get(defaultStationCode),
                isJA: defaultStationCode === Site.JP,
                isKO: defaultStationCode === Site.KR,
                isEN: defaultStationCode === Site.UK,
                systemSource: getLocalSystemSource()
            });
            return;
        }
        try {
            const response =
                await request.customer.getCustomerDetails.getCustomerDetails();
            localStorage.setItem(
                'stationCode',
                response.data?.stationCode as string
            );
            const res = {
                ...response.data,
                site: getSite(response.data?.stationCode ?? ''),
                siteCode: SiteCodeMap.get(
                    response.data?.stationCode ?? ''
                ) as Site,
                isJA: response.data?.stationCode === Site.JP,
                isKO: response.data?.stationCode === Site.KR,
                isEN: response.data?.stationCode === Site.UK
            };
            const ele: any = document.querySelector('html');

            ele.setAttribute('class', response.data?.stationCode);
            if (response.data?.stationCode === Site.UK) {
                document.title = 'THE CKB';
            } else {
                document.title = 'THE CKB';
            }
            set(atomCustomerDetail, res);
            await 1;
            user.setState(res);
        } catch {
            localStorage.setItem('stationCode', defaultStationCode);
        }
    }
);

// 请教枝林
// 获取用户信息
export const user = subscribe<USER_PROPS>();
export const isJA = () => user.getState()?.stationCode === Site.JP;
export const isKO = () => user.getState()?.stationCode === Site.KR;
export const isEN = () => user.getState()?.stationCode === Site.UK;

export default atomRequestCustomerDetail;
